import { get } from 'lodash'

import template from './epromConfiguration.html'
import repeatController from '../../../../../ui-formly/types/repeater/controller'
import selectAsyncUtils from '../../../../../ui-formly/types/selectAsync/utils'
import server from '../../../Server/index'

function formlyEpromConfigurations(authService) {
  var formly = {
    key: 'EpromConfigurations',
    name: 'EpromConfigurations',
    controller: repeatController,
    templateUrl: template,
    templateOptions: {
      addText: 'Add EPROM',
      fields: [
        {
          key: 'Name',
          name: 'Name',
          type: 'input',
          templateOptions: {
            label: 'EPROM',
            required: true
          },
          className: 'col-xs-2'
        },
        {
          key: 'Label',
          name: 'Label',
          type: 'input',
          templateOptions: {
            label: 'EPROM Label',
            required: true
          },
          className: 'col-xs-2'
        },
        {
          key: 'ThemeId',
          name: 'ThemeId',
          type: 'selectAsync',
          templateOptions: {
            label: 'Theme',
            query: selectAsyncUtils.getQuery(server, 'themeQuery'),
            saveNewItem: selectAsyncUtils.getSave(server, 'themeSave'),
            showAddButton: authService.hasPermission('machineEdit'),
            getDefaultItem: function (model) {
              return {
                Id: get(model, 'Theme.Id'),
                Name: get(model, 'Theme.Name')
              }
            },
            updateNameProp: 'Theme.Name'
          },
          className: 'col-xs-6'
        },
        {
          key: 'copyDelete',
          type: 'copyDeleteButtons',
          templateOptions: {
            label: ' '
          },
          className: 'col-xs-2'
        },
      ]
    }
  }

  return [formly]
}

export default formlyEpromConfigurations
